export const REQUEST_AUTHENTICATION = 'REQUEST_AUTHENTICATION'
export const RECEIVE_AUTHENTICATION_SUCCESS = 'RECEIVE_AUTHENTICATION_SUCCESS'
export const RECEIVE_AUTHENTICATION_ERROR = 'RECEIVE_AUTHENTICATION_ERROR'
export const CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION'
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR'

// Users
export const REQUEST_USER_ERROR = 'REQUEST_USER_ERROR'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'
export const CLEAR_USER = 'CLEAR_USER'
export const CREATE_USER = 'CREATE_USER'
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR'
export const ARCHIVE_USER_SUCCESS = 'ARCHIVE_USER_SUCCESS'
export const ARCHIVE_USER_ERROR = 'ARCHIVE_USER_ERROR'
export const RESTORE_USER_SUCCESS = 'RESTORE_USER_SUCCESS'
export const RESTORE_USER_ERROR = 'RESTORE_USER_ERROR'
export const DELETE_USER = 'DELETE_USER'
export const REQUEST_USER_LIST_SUCCESS = 'REQUEST_USER_LIST_SUCCESS'
export const REQUEST_USER_LIST_ERROR = 'REQUEST_USER_LIST_ERROR'
export const REQUEST_ARCHIVE_USER_LIST_SUCCESS = 'REQUEST_ARCHIVE_USER_LIST_SUCCESS'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const ENABLE_LOADING_INDICATOR = 'ENABLE_LOADING_INDICATOR'
export const DISABLE_LOADING_INDICATOR = 'DISABLE_LOADING_INDICATOR'
export const REQUEST_ADD_USERS_TO_TASK_SUCCESS = 'REQUEST_ADD_USERS_TO_TASK_SUCCESS'
export const REQUEST_ADD_USERS_TO_TASK_ERROR = 'REQUEST_ADD_USERS_TO_TASK_ERROR'
export const REQUEST_REMOVE_USERS_TO_TASK_SUCCESS = 'REQUEST_REMOVE_USERS_TO_TASK_SUCCESS'
export const REQUEST_REMOVE_USERS_TO_TASK_ERROR = 'REQUEST_REMOVE_USERS_TO_TASK_ERROR'

// Role
export const REQUEST_GET_ALL_ROLES_SUCCESS = 'REQUEST_GET_ALL_ROLES_SUCCESS'
export const REQUEST_GET_ALL_ROLES_ERROR = 'REQUEST_GET_ALL_ROLES_ERROR'
export const REQUEST_GET_ROLE_BY_ID_SUCCESS = 'REQUEST_GET_ROLE_BY_ID_SUCCESS'
export const REQUEST_GET_ROLE_BY_ID_ERROR = 'REQUEST_GET_ROLE_BY_ID_ERROR'

// Import
export const REQUEST_STAGE_FILE_SUCCESS = 'REQUEST_STAGE_FILE_SUCCESS'
export const REQUEST_STAGE_FILE_ERROR = 'REQUEST_STAGE_FILE_ERROR'
export const REQUEST_IMPORT_FILE_SUCCESS = 'REQUEST_IMPORT_FILE_SUCCESS'
export const REQUEST_IMPORT_FILE_ERROR = 'REQUEST_IMPORT_FILE_ERROR'
export const REQUEST_GET_ROWS_SUCCESS = 'REQUEST_GET_ROWS_SUCCESS'
export const REQUEST_GET_ROWS_ERROR = 'REQUEST_GET_ROWS_ERROR'
export const REQUEST_GET_KEYS_SUCCESS = 'REQUEST_GET_KEYS_SUCCESS'
export const REQUEST_GET_KEYS_ERROR = 'REQUEST_GET_KEYS_ERROR'
export const REQUEST_DELETE_INPUT_SET_SUCCESS = 'REQUEST_DELETE_INPUT_SET_SUCCESS'
export const REQUEST_DELETE_INPUT_SET_ERROR = 'REQUEST_DELETE_INPUT_SET_ERROR'
export const CLEAR_PREVIOUS_UPLOAD = 'CLEAR_PREVIOUS_UPLOAD'

// Account
export const REQUEST_CLEAR_ACCOUNT_ERROR = 'REQUEST_CLEAR_ACCOUNT_ERROR'
export const REQUEST_RESET_PASSWORD_ADMIN_SUCCESS = 'REQUEST_RESET_PASSWORD_ADMIN_SUCCESS'
export const REQUEST_RESET_PASSWORD_ADMIN_ERROR = 'REQUEST_RESET_PASSWORD_ADMIN_ERROR'
export const REQUEST_SUBMIT_PASSWORD_ERROR = 'REQUEST_SUBMIT_PASSWORD_ERROR'
export const REQUEST_SUBMIT_PASSWORD_SUCCESS = 'REQUEST_SUBMIT_PASSWORD_SUCCESS'
export const REQUEST_SEND_FORGOT_PASSWORD_EMAIL_ERROR = 'REQUEST_SEND_FORGOT_PASSWORD_EMAIL_ERROR'
export const REQUEST_SEND_FORGOT_PASSWORD_EMAIL_SUCCESS = 'REQUEST_SEND_FORGOT_PASSWORD_EMAIL_SUCCESS'
export const RESET_SUBMIT_SUCCESS_MESSAGE = 'RESET_SUBMIT_SUCCESS_MESSAGE'

// Job Tasks
export const REQUEST_GET_ALL_TASKS_SUCCESS = 'REQUEST_GET_ALL_TASKS_SUCCESS'
export const REQUEST_GET_ALL_TASKS_ERROR = 'REQUEST_GET_ALL_TASKS_ERROR'
export const REQUEST_GET_MAP_TASK_LOCATIONS_SUCCESS = 'REQUEST_GET_MAP_TASK_LOCATIONS_SUCCESS'
export const REQUEST_GET_MAP_TASK_LOCATIONS_ERROR = 'REQUEST_GET_MAP_TASK_LOCATIONS_ERROR'
export const REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_SUCCESS = 'REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_SUCCESS'
export const REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_ERROR = 'REQUEST_GET_WORKER_MAP_TASK_LOCATIONS_ERROR'
export const REQUEST_GET_ACTIVE_TASK_RANGE_SUCCESS = 'REQUEST_GET_ACTIVE_TASK_RANGE_SUCCESS'
export const REQUEST_GET_ACTIVE_TASK_RANGE_ERROR = 'REQUEST_GET_ACTIVE_TASK_RANGE_ERROR'
export const REQUEST_GET_ARCHIVED_TASK_RANGE_SUCCESS = 'REQUEST_GET_ARCHIVED_TASK_RANGE_SUCCESS'
export const REQUEST_GET_ARCHIVED_TASK_RANGE_ERROR = 'REQUEST_GET_ARCHIVED_TASK_RANGE_ERROR'
export const REQUEST_GET_ARCHIVED_TASKS_SUCCESS = 'REQUEST_GET_ARCHIVED_TASKS_SUCCESS'
export const REQUEST_GET_ARCHIVED_TASKS_ERROR = 'REQUEST_GET_ARCHIVED_TASKS_ERROR'
export const REQUEST_GET_DELAYED_TASKS_SUCCESS = 'REQUEST_GET_DELAYED_TASKS_SUCCESS'
export const REQUEST_GET_DELAYED_TASKS_ERROR = 'REQUEST_GET_DELAYED_TASKS_ERROR'
export const REQUEST_GET_IN_PROGRESS_TASKS_SUCCESS = 'REQUEST_GET_IN_PROGRESS_TASKS_SUCCESS'
export const REQUEST_GET_IN_PROGRESS_TASKS_ERROR = 'REQUEST_GET_IN_PROGRESS_TASKS_ERROR'
export const REQUEST_GET_COMPLETED_TASKS_SUCCESS = 'REQUEST_GET_COMPLETED_TASKS_SUCCESS'
export const REQUEST_GET_COMPLETED_TASKS_ERROR = 'REQUEST_GET_COMPLETED_TASKS_ERROR'
export const REQUEST_GET_TASK_BY_ID_SUCCESS = 'REQUEST_GET_TASK_BY_ID_SUCCESS'
export const REQUEST_GET_TASK_BY_ID_ERROR = 'REQUEST_GET_TASK_BY_ID_ERROR'
export const REQUEST_GET_ACTIVE_TASK_COUNT = 'REQUEST_GET_ACTIVE_TASK_COUNT'
export const REQUEST_GET_ARCHIVED_TASK_COUNT = 'REQUEST_GET_ARCHIVED_TASK_COUNT'
export const REQUEST_CREATE_TASK_SUCCESS = 'REQUEST_CREATE_TASK_SUCCESS'
export const REQUEST_CREATE_TASK_ERROR = 'REQUEST_CREATE_TASK_ERROR'
export const REQUEST_DELETE_TASK_SUCCESS = 'REQUEST_DELETE_TASK_SUCCESS'
export const REQUEST_DELETE_TASK_ERROR = 'REQUEST_DELETE_TASK_ERROR'
export const REQUEST_UPDATE_TASK_SUCCESS = 'REQUEST_UPDATE_TASK_SUCCESS'
export const REQUEST_UPDATE_TASK_ERROR = 'REQUEST_UPDATE_TASK_ERROR'
export const REQUEST_ARCHIVE_TASK_SUCCESS = 'REQUEST_ARCHIVE_TASK_SUCCESS'
export const REQUEST_ARCHIVE_TASK_ERROR = 'REQUEST_ARCHIVE_TASK_ERROR'
export const REQUEST_COMPLETE_TASK_SUCCESS = 'REQUEST_COMPLETE_TASK_SUCCESS'
export const REQUEST_COMPLETE_TASK_ERROR = 'REQUEST_COMPLETE_TASK_ERROR'
export const REQUEST_RESTORE_TASK_SUCCESS = 'REQUEST_RESTORE_TASK_SUCCESS'
export const REQUEST_RESTORE_TASK_ERROR = 'REQUEST_RESTORE_TASK_ERROR'
export const REQUEST_GET_TASK_NUMBER_SUCCESS = 'REQUEST_GET_TASK_NUMBER_SUCCESS'
export const REQUEST_GET_TASK_NUMBER_ERROR = 'REQUEST_GET_TASK_NUMBER_ERROR'
export const CLEAR_SELECTED_TASK = 'CLEAR_SELECTED_TASK'
export const ASSIGN_TASK = 'ASSIGN_TASK'
export const REQUEST_TASK_NUMBER_ADDRESS_SUCCESS = 'REQUEST_TASK_NUMBER_ADDRESS_SUCCESS'
export const REQUEST_TASK_NUMBER_ADDRESS_ERROR = 'REQUEST_TASK_NUMBER_ADDRESS_ERROR'
export const REQUEST_GET_DELAYED_TASK_COUNT = "REQUEST_GET_DELAYED_TASK_COUNT"
export const REQUEST_GET_DELAYED_TASK_RANGE_SUCCESS = 'REQUEST_GET_DELAYED_TASK_RANGE_SUCCESS'
export const REQUEST_GET_DELAYED_TASK_RANGE_ERROR = 'REQUEST_GET_DELAYED_TASK_RANGE_ERROR'
export const REQUEST_GET_IN_PROGRESS_TASK_COUNT = "REQUEST_GET_IN_PROGRESS_TASK_COUNT"
export const REQUEST_GET_IN_PROGRESS_TASK_RANGE_SUCCESS = 'REQUEST_GET_IN_PROGRESS_TASK_RANGE_SUCCESS'
export const REQUEST_GET_IN_PROGRESS_TASK_RANGE_ERROR = 'REQUEST_GET_IN_PROGRESS_TASK_RANGE_ERROR'


// Routes
export const REQUEST_GET_ALL_ROUTES_SUCCESS = 'REQUEST_GET_ALL_ROUTES_SUCCESS'
export const REQUEST_GET_ALL_ROUTES_ERROR = 'REQUEST_GET_ALL_ROUTES_ERROR'
export const REQUEST_GET_ACTIVE_ROUTE_RANGE_SUCCESS = 'REQUEST_GET_ACTIVE_ROUTE_RANGE_SUCCESS'
export const REQUEST_GET_ARCHIVED_ROUTE_RANGE_SUCCESS = 'REQUEST_GET_ARCHIVED_ROUTE_RANGE_SUCCESS'
export const REQUEST_GET_ACTIVE_ROUTE_RANGE_ERROR = 'REQUEST_GET_ACTIVE_ROUTE_RANGE_ERROR'
export const REQUEST_GET_ARCHIVED_ROUTE_RANGE_ERROR = 'REQUEST_GET_ARCHIVED_ROUTE_RANGE_ERROR'
export const REQUEST_GET_ROUTE_BY_ID_SUCCESS = 'REQUEST_GET_ROUTE_BY_ID_SUCCESS'
export const REQUEST_GET_ROUTE_BY_ID_ERROR = 'REQUEST_GET_ROUTE_BY_ID_ERROR'
export const REQUEST_GET_ACTIVE_ROUTE_COUNT = 'REQUEST_GET_ACTIVE_ROUTE_COUNT'
export const REQUEST_GET_ARCHIVED_ROUTE_COUNT = 'REQUEST_GET_ARCHIVED_ROUTE_COUNT'
export const REQUEST_CREATE_ROUTE_SUCCESS = 'REQUEST_CREATE_ROUTE_SUCCESS'
export const REQUEST_CREATE_ROUTE_ERROR = 'REQUEST_CREATE_ROUTE_ERROR'
export const REQUEST_DELETE_ROUTE_SUCCESS = 'REQUEST_DELETE_ROUTE_SUCCESS'
export const REQUEST_DELETE_ROUTE_ERROR = 'REQUEST_DELETE_ROUTE_ERROR'
export const REQUEST_UPDATE_ROUTE_SUCCESS = 'REQUEST_UPDATE_ROUTE_SUCCESS'
export const REQUEST_UPDATE_ROUTE_ERROR = 'REQUEST_UPDATE_ROUTE_ERROR'
export const REQUEST_COMPLETE_ROUTE_SUCCESS = 'REQUEST_COMPLETE_ROUTE_SUCCESS'
export const REQUEST_COMPLETE_ROUTE_ERROR = 'REQUEST_COMPLETE_ROUTE_ERROR'
export const REQUEST_ARCHIVE_ROUTE_SUCCESS = 'REQUEST_ARCHIVE_ROUTE_SUCCESS'
export const REQUEST_ARCHIVE_ROUTE_ERROR = 'REQUEST_ARCHIVE_ROUTE_ERROR'
export const REQUEST_RESTORE_ROUTE_SUCCESS = 'REQUEST_RESTORE_ROUTE_SUCCESS'
export const REQUEST_RESTORE_ROUTE_ERROR = 'REQUEST_RESTORE_ROUTE_ERROR'
export const REQUEST_GET_ROUTE_NUMBERS_SUCCESS = 'REQUEST_GET_ROUTE_NUMBERS_SUCCESS'
export const REQUEST_GET_ROUTE_NUMBERS_ERROR = 'REQUEST_GET_ROUTE_NUMBERS_ERROR'
export const REQUEST_GET_ROUTE_LOCATIONS_SUCCESS = 'REQUEST_GET_ROUTE_LOCATIONS_SUCCESS'
export const REQUEST_GET_ROUTE_LOCATIONS_ERROR = 'REQUEST_GET_ROUTE_LOCATIONS_ERROR'
export const REQUEST_SET_SELECTED_ROUTE_ERROR = 'REQUEST_SET_SELECTED_ROUTE_ERROR'
export const REQUEST_SET_SELECTED_ROUTE_SUCCESS = 'REQUEST_SET_SELECTED_ROUTE_SUCCESS'
export const CLEAR_SELECTED = 'CLEAR_SELECTED'
export const CLEAR_LOCATIONS = 'CLEAR_LOCATIONS'
export const REQUEST_SET_SELECTED_ROUTE_INCOMPLETE_TASKS = 'REQUEST_SET_SELECTED_ROUTE_INCOMPLETE_TASKS'
export const REQUEST_GET_ALL_ARCHIVED_ROUTES_SUCCESS = 'REQUEST_GET_ALL_ARCHIVED_ROUTES_SUCCESS'
export const REQUEST_GET_ALL_ARCHIVED_ROUTES_ERROR = 'REQUEST_GET_ALL_ARCHIVED_ROUTES_ERROR'
export const REQUEST_ADD_TASKS_TO_ROUTE_SUCCESS = 'REQUEST_ADD_TASKS_TO_ROUTE_SUCCESS'
export const REQUEST_ADD_TASKS_TO_ROUTE_ERROR = 'REQUEST_ADD_TASKS_TO_ROUTE_ERROR'
export const REQUEST_CLEAR_TASKS_FROM_ROUTE_SUCCESS = 'REQUEST_CLEAR_TASKS_FROM_ROUTE_SUCCESS'
export const REQUEST_CLEAR_TASKS_FROM_ROUTE_ERROR = 'REQUEST_CLEAR_TASKS_FROM_ROUTE_ERROR'
export const CLEAR_ROUTES = 'CLEAR_ROUTES'

// Tags
export const REQUEST_GET_ALL_TAGS_SUCCESS = 'REQUEST_GET_ALL_TAGS_SUCCESS'
export const REQUEST_GET_ALL_TAGS_ERROR = 'REQUEST_GET_ALL_TAGS_ERROR'
export const REQUEST_GET_TAG_BY_ID_SUCCESS = 'REQUEST_GET_TAG_BY_ID_SUCCESS'
export const REQUEST_GET_TAG_BY_ID_ERROR = 'REQUEST_GET_TAG_BY_ID_ERROR'
export const REQUEST_CREATE_TAG_SUCCESS = 'REQUEST_CREATE_TAG_SUCCESS'
export const REQUEST_CREATE_TAG_ERROR = 'REQUEST_CREATE_TAG_ERROR'
export const REQUEST_DELETE_TAG_SUCCESS = 'REQUEST_DELETE_TAG_SUCCESS'
export const REQUEST_DELETE_TAG_ERROR = 'REQUEST_DELETE_TAG_ERROR'
export const REQUEST_UPDATE_TAG_SUCCESS = 'REQUEST_UPDATE_TAG_SUCCESS'
export const REQUEST_UPDATE_TAG_ERROR = 'REQUEST_UPDATE_TAG_ERROR'

// Planning
export const REQUEST_GET_PLANNING_PREVIEW_ROUTES_SUCCESS = 'REQUEST_GET_PLANNING_PREVIEW_ROUTES_SUCCESS'
export const REQUEST_GET_PLANNING_PREVIEW_ROUTES_ERROR = 'REQUEST_GET_PLANNING_PREVIEW_ROUTES_ERROR'
export const REQUEST_GET_PLANNING_SAVE_ROUTES_SUCCESS = 'REQUEST_GET_PLANNING_SAVE_ROUTES_SUCCESS'
export const REQUEST_GET_PLANNING_SAVE_ROUTES_ERROR = 'REQUEST_GET_PLANNING_SAVE_ROUTES_ERROR'
export const REQUEST_PLANNING_SAVE_MAP_BOUNDS = 'REQUEST_PLANNING_SAVE_MAP_BOUNDS'
